import { render } from "./Album202511.vue?vue&type=template&id=323c2970&scoped=true"
import script from "./Album202511.vue?vue&type=script&lang=js"
export * from "./Album202511.vue?vue&type=script&lang=js"

import "./Album202511.vue?vue&type=style&index=0&id=323c2970&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-323c2970"]])

export default __exports__